import React from 'react';
import styled from 'styled-components';
import variables from '@ingka/variables/design-tokens';
import cssIngka from '@ingka/variables/colours-css';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

interface ItemProps {
  imgSrc: IGatsbyImageData;
  captionId: string;
  children?: React.ReactNode;
}

const StyledItem = styled.li`
  padding: 1px;
  background: ${cssIngka.colourNeutral2};
  @media (min-width: ${variables.breakpointM}) {
    width: 275px;
  }
`;

const StyledDetails = styled.div`
  padding: 20px;
  img {
    margin-bottom: 14px;
    display: block;
  }
`;

export const OnboardingItem: React.FC<ItemProps> = ({
  children,
  imgSrc,
  captionId,
}): JSX.Element => {
  return (
    <StyledItem aria-describedby={captionId}>
      <GatsbyImage image={imgSrc} alt="" role="presentation" />
      <StyledDetails>{children}</StyledDetails>
    </StyledItem>
  );
};
